import styled from 'styled-components';

export const JobModalContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr auto;
  min-height: 16rem;
  width: 40rem;
`;

export const JobModalSummaryLine = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
`;

export const JobModalType = styled.div`
  font-size: 1.25rem;
  text-transform: capitalize;
`;

export const JobModalStatus = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.75rem;
`;

export const JobModalRunInfo = styled.div`
  margin: 0.5rem 0;
`;

export const JobModalLogs = styled.pre`
  margin: 1rem 0;
  font-size: 0.875rem;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.background};
  box-sizing: border-box;
  width: 40rem;
  max-height: 50vh;
  overflow: auto;
`;

export const SpacebetweenInfo = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
`;

export const ShowLogsButton = styled.div`
  position: absolute;
  right: 0;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const ModalButtons = styled.div`
  text-align: right;

  > * {
    margin-right: 0.5rem;

    &:frist-child {
      margin-right: 0;
    }
  }
`;

export const CreateModalContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr auto auto;
  min-height: 16rem;
  width: 40rem;
`;

export const CreateInputGrid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-gap: 0.5rem;
  align-items: center;
  height: fit-content;
  margin-bottom: 1rem;
`;

export const CreateInputTitle = styled.div`
  margin: 1rem 0 0;
`;

export const CreateErrorContainer = styled.div``;

export const JobTypeSelectContainer = styled.div`
  z-index: 999;
  > div {
    width: fill-available;
    z-index: 999;
  }
`;
